import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { PortRow } from './templates/PortRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const CoilLengthRow = ({ manifold }: Props) => {
  return (
    <PortRow
      name="Supplied Coil Length (m)"
      manifold={manifold}
      getValue={room => (room.pipeDiameterInMillimetres === 17 ? 'See cutting plan' : room.suppliedCoilLengthInMetres)}
    />
  );
};
